import request from '@/utils/request'
// 数智化动态人才培养一览表 统计
export function talentCultivationTable (data) {
    return request({
      url: '/admin/trial/statistics',
      method: 'POST',
      data
    })
  }